import { Button, Card, Col, Form, Input, Row, Select, Space, DatePicker } from "antd"
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons"
import type React from "react"
import dayjs, { type Dayjs } from "dayjs"

const { RangePicker } = DatePicker

export interface AddVocabularyFilterValues {
  search?: string
  source_type?: string
  status?: string
  date_range?: [Dayjs, Dayjs] | null
  start_date?: string
  end_date?: string
}

interface AddVocabularyFilterFormProps {
  onSearch: (values: AddVocabularyFilterValues) => void
  loading?: boolean
  initialValues?: AddVocabularyFilterValues
}

export const SOURCE_TYPE_OPTIONS = [
  { label: "Tất cả nguồn", value: "" },
  { label: "Thêm nhanh", value: "input_text" },
  { label: "Nhập thủ công", value: "manual" },
  { label: "Nhập Excel", value: "import_excel" },
  { label: "Nhập Anki", value: "import_anki" },
  { label: "Nhập Anki Text", value: "import_anki_text" },
  { label: "Nhập Quizlet", value: "import_quizlet" },
  { label: "AI quét ảnh", value: "ai_image" },
  { label: "AI quét PDF", value: "ai_pdf" },
  { label: "AI Chat", value: "ai_chat" },
  { label: "AI trích xuất", value: "ai_extract_text" },
]

export const STATUS_OPTIONS = [
  { label: "Tất cả trạng thái", value: "" },
  { label: "Đã lưu", value: "committed" },
  { label: "Bỏ cuộc", value: "previewed" },
  { label: "Lỗi file", value: "failed" },
]

export const AddVocabularyFilterForm: React.FC<AddVocabularyFilterFormProps> = ({
  onSearch,
  loading = false,
  initialValues,
}) => {
  const [form] = Form.useForm()

  const handleFinish = (values: any) => {
    let start_date: string | undefined
    let end_date: string | undefined

    if (values.date_range && values.date_range.length === 2) {
      start_date = values.date_range[0]?.format("YYYY-MM-DD")
      end_date = values.date_range[1]?.format("YYYY-MM-DD")
    }

    onSearch({
      search: values.search?.trim() || undefined,
      source_type: values.source_type || undefined,
      status: values.status || undefined,
      start_date,
      end_date,
    })
  }

  const handleReset = () => {
    form.resetFields()
    onSearch({
      search: undefined,
      source_type: undefined,
      status: undefined,
      start_date: undefined,
      end_date: undefined,
    })
  }

  const initialRange: [Dayjs, Dayjs] | undefined =
    initialValues?.start_date && initialValues?.end_date
      ? [dayjs(initialValues.start_date), dayjs(initialValues.end_date)]
      : undefined

  return (
    <Card className="mb-2 shadow-xs">
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{
          search: initialValues?.search || "",
          source_type: initialValues?.source_type || "",
          status: initialValues?.status || "",
          date_range: initialRange,
        }}
      >
        <Row gutter={[16, 8]}>
          <Col xs={24} sm={12} md={6}>
            <Form.Item label="Người dùng (Tên, Email hoặc #ID)" name="search">
              <Input placeholder="Nhập tên, email hoặc #ID..." allowClear />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Form.Item label="Nguồn nhập" name="source_type">
              <Select options={SOURCE_TYPE_OPTIONS} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Form.Item label="Trạng thái" name="status">
              <Select options={STATUS_OPTIONS} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Form.Item label="Khoảng thời gian" name="date_range">
              <RangePicker format="DD/MM/YYYY" className="w-full" allowClear />
            </Form.Item>
          </Col>

          <Col xs={24} className="flex justify-end">
            <Space>
              <Button icon={<ReloadOutlined />} onClick={handleReset}>
                Đặt lại
              </Button>
              <Button type="primary" htmlType="submit" icon={<SearchOutlined />} loading={loading}>
                Tìm kiếm
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Card>
  )
}

export default AddVocabularyFilterForm
